export const COLORS = {
    red: "#FD0014",
    white: "#fff",
    lightgray:"#505050",
    blue: "#030762",
    lightgray2: "#F9F9F9",
    kprimary: "#556EE6",
    ksecondary: "#74788D",
    kseconddayx: "#747891",
    kblack: "#000000",
    kblack2: "#171725",
    kgrey: "#555B6D",
    kblackCom: "#495057",
    kblackComx: "#49505C",
    kwhite: "#FFFFFF",
    klightGreen:"#D6F3E9",
    kdeepBlue: "#0F153A",
    kLightGray: "#EFF2F7",
    kbackGray: "#D7D7D7",
    kblue : "#13257B",
    kdeepBlue: "#0F153A",
    kbadge: "#FA6A6A",
    kborder: "#E5E5F2",
    kdanger: "#E72E1E",
    ksmallbutton: "#EAEAEA",
    kbackGray2: "#44444F",
    kgreen: "#34c38f",
    kbackground: "#F8F8FB"
    

    
}

export const SIZES = {
    h3: "40px",
    h4: "36px",
    h5: "16px",
    h6: "14px",
    padding: "100px",
    body5: "13px"
}

